
import { useState } from 'react';

const coldBrewGuides = [
  {
    id: 'sencha-cold',
    name: '煎茶（水出し）',
    nameEn: 'Cold Brew Sencha',
    color: '#7B8C3E',
    image: 'https://public.readdy.ai/ai/img_res/323fa018b2c2af1dec5a6678746bd204.jpg',
    waterTemp: '冷水（常温〜冷蔵庫）',
    teaAmount: 'ティーバッグ2個',
    waterAmount: '500ml',
    brewTime: '3〜6時間（冷蔵庫）',
    quickMethod: '常温で1時間 → 冷蔵庫で1時間',
    tips: '水出しにすると渋みがほとんど出ず、旨味と甘みが際立つまろやかな味わいに。夏場のリフレッシュに最適です。氷を入れたグラスに注いでどうぞ。',
    garnish: 'ミントの葉やレモンスライスを添えると爽やかさアップ',
  },
  {
    id: 'hojicha-cold',
    name: 'ほうじ茶（水出し）',
    nameEn: 'Cold Brew Hojicha',
    color: '#A0724A',
    image: 'https://readdy.ai/api/search-image?query=cold%20brew%20Japanese%20roasted%20hojicha%20tea%20in%20a%20tall%20clear%20glass%20pitcher%20with%20ice%20cubes%20warm%20amber%20brown%20color%20on%20a%20minimal%20white%20marble%20surface%20bright%20natural%20daylight%20professional%20beverage%20photography%20clean%20aesthetic%20summer%20refreshing&width=600&height=400&seq=coldbrew002&orientation=landscape',
    waterTemp: '冷水（常温〜冷蔵庫）',
    teaAmount: 'ティーバッグ2個',
    waterAmount: '500ml',
    brewTime: '4〜8時間（冷蔵庫）',
    quickMethod: '少量の熱湯で30秒抽出 → 冷水と氷で急冷',
    tips: '水出しでも香ばしさはしっかり残りつつ、すっきりとした後味に。急冷法なら短時間で香り高いアイスほうじ茶が楽しめます。',
    garnish: 'ミルクを加えてアイスほうじ茶ラテにするのもおすすめ',
  },
  {
    id: 'wakocha-cold',
    name: '和紅茶（水出し）',
    nameEn: 'Cold Brew Japanese Black Tea',
    color: '#C4787A',
    image: 'https://readdy.ai/api/search-image?query=cold%20brew%20Japanese%20black%20tea%20wakocha%20in%20a%20tall%20clear%20glass%20pitcher%20with%20ice%20cubes%20deep%20reddish%20amber%20color%20with%20lemon%20slice%20on%20a%20minimal%20white%20marble%20surface%20bright%20natural%20daylight%20professional%20beverage%20photography%20clean%20aesthetic%20summer%20refreshing&width=600&height=400&seq=coldbrew003&orientation=landscape',
    waterTemp: '冷水（常温〜冷蔵庫）',
    teaAmount: 'ティーバッグ2個',
    waterAmount: '500ml',
    brewTime: '6〜8時間（冷蔵庫）',
    quickMethod: '少量の熱湯で1分抽出 → 冷水と氷で急冷',
    tips: '水出しの和紅茶は渋みがゼロに近く、フルーティーな甘みが引き立ちます。ストレートでも十分美味しいですが、はちみつを少し加えても絶品。',
    garnish: 'レモンスライスやオレンジピールとの相性が抜群',
  },
  {
    id: 'oolong-cold',
    name: '烏龍茶（水出し）',
    nameEn: 'Cold Brew Oolong',
    color: '#C4A24A',
    image: 'https://readdy.ai/api/search-image?query=cold%20brew%20Japanese%20oolong%20tea%20in%20a%20tall%20clear%20glass%20pitcher%20with%20ice%20cubes%20golden%20amber%20color%20on%20a%20minimal%20white%20marble%20surface%20bright%20natural%20daylight%20professional%20beverage%20photography%20clean%20aesthetic%20summer%20refreshing&width=600&height=400&seq=coldbrew004&orientation=landscape',
    waterTemp: '冷水（常温〜冷蔵庫）',
    teaAmount: 'ティーバッグ2個',
    waterAmount: '500ml',
    brewTime: '4〜6時間（冷蔵庫）',
    quickMethod: '常温で1時間 → 冷蔵庫で1時間',
    tips: '水出しにすると花のような華やかな香りがより繊細に感じられます。食事中のお茶としても最適で、脂っこい料理との相性も抜群です。',
    garnish: 'ジャスミンの花や桃のスライスを浮かべると華やかに',
  },
];

const steps = [
  {
    num: '01',
    icon: 'ri-drop-line',
    title: 'ボトルに水を入れる',
    desc: '清潔なボトルやピッチャーに冷水500mlを用意します',
  },
  {
    num: '02',
    icon: 'ri-leaf-line',
    title: 'ティーバッグを入れる',
    desc: 'ティーバッグ2個をそのまま水に入れます',
  },
  {
    num: '03',
    icon: 'ri-fridge-line',
    title: '冷蔵庫で抽出',
    desc: '冷蔵庫に入れて、お茶の種類に合わせた時間じっくり抽出します',
  },
  {
    num: '04',
    icon: 'ri-goblet-line',
    title: '完成！',
    desc: 'ティーバッグを取り出し、氷を入れたグラスに注いでお楽しみください',
  },
];

export default function TeaColdBrewGuide() {
  const [activeTab, setActiveTab] = useState('sencha-cold');
  const activeGuide = coldBrewGuides.find((g) => g.id === activeTab) || coldBrewGuides[0];

  return (
    <section className="py-16 sm:py-24 md:py-32 bg-white" aria-labelledby="cold-brew-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-sky-50 text-sky-600 text-xs tracking-[0.15em] rounded-full mb-4 sm:mb-6">
            <i className="ri-snowflake-line" aria-hidden="true"></i>
            COLD BREW GUIDE
          </span>
          <h2
            id="cold-brew-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-3 sm:mb-4 tracking-[0.1em]"
          >
            水出しアイスティーの作り方
          </h2>
          <p className="text-sm sm:text-base text-black/60 font-extralight tracking-wide max-w-xl mx-auto">
            暑い季節にぴったり。水出しならではのまろやかな味わいをお楽しみください
          </p>
        </div>

        {/* Basic Steps */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-14 sm:mb-20">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-gradient-to-b from-sky-50/80 to-white rounded-xl sm:rounded-2xl p-5 sm:p-6 text-center group hover:shadow-lg transition-all duration-300"
            >
              <span className="absolute top-3 right-4 text-[10px] text-sky-300 font-light tracking-widest">
                {step.num}
              </span>
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-sky-100 rounded-xl mx-auto mb-3 sm:mb-4 group-hover:bg-sky-200 transition-colors">
                <i className={`${step.icon} text-xl sm:text-2xl text-sky-600`} aria-hidden="true"></i>
              </div>
              <h3 className="text-sm sm:text-base font-light text-black mb-1.5 tracking-wide">
                {step.title}
              </h3>
              <p className="text-xs sm:text-sm text-black/50 font-extralight leading-relaxed">
                {step.desc}
              </p>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 sm:-right-4 w-6 h-6 flex items-center justify-center text-sky-300">
                  <i className="ri-arrow-right-s-line text-lg" aria-hidden="true"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Tea Type Tabs */}
        <div className="flex justify-center mb-10 sm:mb-14">
          <div className="inline-flex bg-sky-50 rounded-full p-1">
            {coldBrewGuides.map((guide) => (
              <button
                key={guide.id}
                onClick={() => setActiveTab(guide.id)}
                className={`px-3 sm:px-5 py-2 sm:py-2.5 rounded-full text-xs sm:text-sm tracking-wide whitespace-nowrap cursor-pointer transition-all duration-300 ${
                  activeTab === guide.id
                    ? 'bg-white text-black font-light shadow-md'
                    : 'text-black/50 font-extralight hover:text-black/80'
                }`}
              >
                {guide.name.replace('（水出し）', '')}
              </button>
            ))}
          </div>
        </div>

        {/* Active Guide Detail */}
        <div className="grid lg:grid-cols-2 gap-10 sm:gap-14 lg:gap-20 items-start">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[3/2] rounded-xl sm:rounded-2xl overflow-hidden shadow-lg">
              <img
                src={activeGuide.image}
                alt={`${activeGuide.name}`}
                className="w-full h-full object-cover object-top transition-opacity duration-500"
                loading="lazy"
                width="600"
                height="400"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 sm:-bottom-6 sm:-left-6 bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 shadow-lg max-w-[200px] sm:max-w-[240px]">
              <div className="flex items-center gap-2 mb-2">
                <i className="ri-sparkling-line text-sm text-amber-500" aria-hidden="true"></i>
                <span className="text-xs font-light text-black/60 tracking-wide">アレンジ</span>
              </div>
              <p className="text-xs sm:text-sm text-black/70 font-extralight leading-relaxed">
                {activeGuide.garnish}
              </p>
            </div>
          </div>

          {/* Details */}
          <div>
            <div className="flex items-center gap-3 mb-4 sm:mb-6">
              <div
                className="w-2 h-2 rounded-full"
                style={{ backgroundColor: activeGuide.color }}
              ></div>
              <span className="text-xs text-black/40 font-light tracking-[0.15em] uppercase">
                {activeGuide.nameEn}
              </span>
            </div>

            <h3 className="text-2xl sm:text-3xl font-extralight text-black mb-6 sm:mb-8 tracking-[0.05em]">
              {activeGuide.name}
            </h3>

            {/* Parameters */}
            <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-6 sm:mb-8">
              <div className="bg-sky-50/80 rounded-xl p-4 sm:p-5">
                <div className="flex items-center gap-2 mb-1.5">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-temp-cold-line text-sm text-sky-600" aria-hidden="true"></i>
                  </div>
                  <span className="text-xs text-black/40 font-light">水温</span>
                </div>
                <p className="text-sm sm:text-base font-light text-black tracking-wide">{activeGuide.waterTemp}</p>
              </div>
              <div className="bg-sky-50/80 rounded-xl p-4 sm:p-5">
                <div className="flex items-center gap-2 mb-1.5">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-scales-3-line text-sm text-sky-600" aria-hidden="true"></i>
                  </div>
                  <span className="text-xs text-black/40 font-light">茶葉量</span>
                </div>
                <p className="text-sm sm:text-base font-light text-black tracking-wide">{activeGuide.teaAmount}</p>
              </div>
              <div className="bg-sky-50/80 rounded-xl p-4 sm:p-5">
                <div className="flex items-center gap-2 mb-1.5">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-drop-line text-sm text-sky-600" aria-hidden="true"></i>
                  </div>
                  <span className="text-xs text-black/40 font-light">水量</span>
                </div>
                <p className="text-sm sm:text-base font-light text-black tracking-wide">{activeGuide.waterAmount}</p>
              </div>
              <div className="bg-sky-50/80 rounded-xl p-4 sm:p-5">
                <div className="flex items-center gap-2 mb-1.5">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-timer-line text-sm text-sky-600" aria-hidden="true"></i>
                  </div>
                  <span className="text-xs text-black/40 font-light">抽出時間</span>
                </div>
                <p className="text-sm sm:text-base font-light text-black tracking-wide">{activeGuide.brewTime}</p>
              </div>
            </div>

            {/* Quick Method */}
            <div className="bg-amber-50/80 rounded-xl p-5 sm:p-6 mb-6 sm:mb-8 border border-amber-100/60">
              <div className="flex items-center gap-2 mb-2">
                <i className="ri-flashlight-line text-base text-amber-600" aria-hidden="true"></i>
                <span className="text-xs font-light tracking-[0.1em] text-amber-700">
                  時短テクニック
                </span>
              </div>
              <p className="text-sm text-black/70 font-extralight leading-relaxed">
                {activeGuide.quickMethod}
              </p>
            </div>

            {/* Tips */}
            <div
              className="rounded-xl p-5 sm:p-6 border-l-4"
              style={{
                borderColor: activeGuide.color,
                backgroundColor: `${activeGuide.color}08`,
              }}
            >
              <div className="flex items-center gap-2 mb-2">
                <i
                  className="ri-lightbulb-line text-base"
                  style={{ color: activeGuide.color }}
                  aria-hidden="true"
                ></i>
                <span
                  className="text-xs font-light tracking-[0.1em]"
                  style={{ color: activeGuide.color }}
                >
                  TIPS
                </span>
              </div>
              <p className="text-sm text-black/60 font-extralight leading-relaxed">
                {activeGuide.tips}
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Comparison Table */}
        <div className="mt-14 sm:mt-20">
          <h3 className="text-lg sm:text-xl font-extralight text-black text-center mb-6 sm:mb-8 tracking-wide">
            <a href="#cold-brew-comparison" className="hover:underline">水出し早見表</a>
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full min-w-[600px] text-sm" id="cold-brew-comparison">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left py-3 px-4 font-light text-black/40 tracking-wide text-xs">お茶の種類</th>
                  <th className="text-left py-3 px-4 font-light text-black/40 tracking-wide text-xs">水量</th>
                  <th className="text-left py-3 px-4 font-light text-black/40 tracking-wide text-xs">茶葉量</th>
                  <th className="text-left py-3 px-4 font-light text-black/40 tracking-wide text-xs">抽出時間</th>
                  <th className="text-left py-3 px-4 font-light text-black/40 tracking-wide text-xs">おすすめ度</th>
                </tr>
              </thead>
              <tbody>
                {coldBrewGuides.map((guide) => (
                  <tr
                    key={guide.id}
                    className={`border-b border-gray-100 cursor-pointer transition-colors ${
                      activeTab === guide.id ? 'bg-sky-50/50' : 'hover:bg-gray-50'
                    }`}
                    onClick={() => setActiveTab(guide.id)}
                  >
                    <td className="py-3.5 px-4">
                      <div className="flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: guide.color }}></div>
                        <span className="font-light text-black tracking-wide">{guide.name.replace('（水出し）', '')}</span>
                      </div>
                    </td>
                    <td className="py-3.5 px-4 text-black/60 font-extralight">{guide.waterAmount}</td>
                    <td className="py-3.5 px-4 text-black/60 font-extralight">{guide.teaAmount}</td>
                    <td className="py-3.5 px-4 text-black/60 font-extralight">{guide.brewTime}</td>
                    <td className="py-3.5 px-4">
                      <div className="flex gap-0.5">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <i
                            key={star}
                            className={`ri-snowflake-line text-xs ${
                              star <= (guide.id === 'sencha-cold' ? 5 : guide.id === 'wakocha-cold' ? 5 : guide.id === 'oolong-cold' ? 4 : 4)
                                ? 'text-sky-500'
                                : 'text-gray-200'
                            }`}
                            aria-hidden="true"
                          ></i>
                        ))}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
